<template>
	<section>
		<AsiPageTitle :icon="icons.infos" :title="$t('pageTitles.admin.information')"/>
		<AsiTabs v-model="activeTab">
			<v-tab key="brands" v-if="rMasterData">
				{{ $t('brand.plural') }}
				<v-icon>{{ icons.customerBusiness }}</v-icon>
			</v-tab>
			<v-tab-item key="brands" v-if="rMasterData">
				<InformationTabBrands />
			</v-tab-item>
		</AsiTabs>
	</section>
</template>

<script lang="ts">
	import {Component} from 'vue-property-decorator';
	import RightChecks from "@/mixins/RightChecks.vue";
	import AsiPageTitle from "@/components/common/AsiPageTitle.vue";
	import Icon from "@/plugins/icons";
	import AsiTabs from "@/components/common/AsiTabs";
	import {mixins} from "vue-class-component";
	import InformationTabBrands from "@/components/information/InformationTabBrands.vue";

	@Component({
		components: {InformationTabBrands, AsiTabs, AsiPageTitle}
	})
	export default class Information extends mixins(RightChecks) {

		private icons = Icon;

		private get activeTab(): number {
			return this.$store.getters['ui/activeTabAdmin']('settings');
		}

		private set activeTab(index: number) {
			this.$store.commit('ui/activeTabAdmin', {key: 'settings', activeTab: index});
		}
	}
</script>

<style scoped lang="scss">

</style>
